const nominowChartDefaults = require('./nominow-chart-defaults.js');

(function () {
	Vue.component('nominow-chart-multibars', {
		mixins: [nominowChartDefaults.mixin],
		template: `<div :id="id"></div>`,
		props: {
			init: {
				type: Object,
				required: true
			},
			chartData: {
				type: Object,
				required: true
			},
			chartRequest: {
				type: Object,
				required: true
			}
		},
		data: function () {
			return {
				id: 'nnchartmultibars-' + new Date().getTime(),
				chart: null
			}
		},
		created: function () {
			Vue.nextTick(() => {
				this.setupChart();
			});
		},
		methods: {
			setupChart: function () {
				var colors = window.getChartColors(this.chartData.Dimension2.length);
				const drilldown = this.chartData.Drilldown;

				var data = Array.prototype.map.call(this.chartData.Dimension2, (el, i) => {
					const dimension = el.Value;
					const values = [];
					Array.prototype.forEach.call(this.chartData.Values, (ev, j) => {
						if (ev.Dimension2 == dimension) {
							values.push(ev.Fact1 || ev.Number);
						}
					});

					return {
						no: i + 1,
						name: dimension,
						data: values,
						color: colors[i]
					}
				});

				//console.log('newdata', data);
				const maxAvg = this.getMultiMaxAverage(data);
				const plotlines = this.getPlotLines(this.chartRequest.plotLines, maxAvg);
				const groups = [];
				for (let i = 0; i < this.chartData.Values.length; i++) {
					if (groups.indexOf(this.chartData.Values[i].Dimension1) == -1) {
						groups.push(this.chartData.Values[i].Dimension1);
					}
				}


				Highcharts.setOptions({ lang: { drillUpText: '◁ Back' } });
				this.chart = Highcharts.chart(this.id, $.extend(true, {}, this.chartDefaults(), {
					chart: {
						type: 'bar'
					},
					xAxis: {
						categories: groups,
						labels: {
							style: {
								color: globalColors.primary.hue9
							}
						},
						lineColor: globalColors.primary.hue1,
						gridLineColor: globalColors.primary.hue1,
						lineWidth: 1,
						tickWidth: 0
					},
					yAxis: {
						max: maxAvg.max,
						title: {
							text: this.chartData.Kpi[0].KPIName,
							style: {
								color: globalColors.primary.hue9
							}
						},
						labels: {
							formatter: function () {
								return this.value;
							},
							style: {
								color: globalColors.primary.hue9
							}
						},
						tickColor: globalColors.primary.hue1,
						lineColor: globalColors.primary.hue1,
						gridLineColor: globalColors.primary.hue1,
						lineWidth: 1,
						tickWidth: 1,
						showFirstLabel: false,
						showLastLabel: false,
						plotLines: window.cloneObject(plotlines)
					},
					tooltip: {
						formatter: function () {
							return `${this.key}<br/><span style="color:${this.color}">${this.series.name}</span>: <strong>${this.y}</strong>`;
						}
					},
					plotOptions: {
						bar: {
							dataLabels: {
								color: globalColors.primary.hue9
							},
							borderWidth: 0
						}
					},
					legend: {
						enabled: true,
						layout: 'horizontal',
						align: 'right',
						verticalAlign: 'bottom',
						floating: false,
						borderWidth: 1,
						backgroundColor: (Highcharts.theme && Highcharts.theme.legendBackgroundColor) || '#FFFFFF',
						shadow: true,
						title: {
							text: this.chartData.Dimension2[0].Tag
						}
					},
					series: data
				}));
				this.$emit('chartReady', this.chart);
			}
		}
	})
})();

